(function(){
  /* ── Sticky Add-to-Cart Bar ── */
  if(!document.querySelector('.product-form__submit')) return;

  /* ── Inject CSS ── */
  var css = document.createElement('style');
  css.textContent = [
    '#jfc-sticky{position:fixed;bottom:0;left:0;right:0;z-index:999;transform:translateY(100%);transition:transform .35s cubic-bezier(.4,0,.2,1);background:rgba(11,11,15,.96);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border-top:1px solid rgba(139,92,246,.25);padding:10px 0;box-shadow:0 -4px 24px rgba(0,0,0,.5);}',
    '#jfc-sticky.vis{transform:translateY(0);}',
    '.jfc-sk-inner{max-width:1200px;margin:0 auto;padding:0 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;}',
    '.jfc-sk-left{display:flex;align-items:center;gap:10px;min-width:0;flex:1;}',
    '.jfc-sk-img{width:44px;height:44px;border-radius:6px;object-fit:cover;border:1px solid rgba(255,255,255,.08);flex-shrink:0;}',
    '.jfc-sk-info{min-width:0;}',
    '.jfc-sk-title{font-size:12px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:200px;}',
    '.jfc-sk-meta{display:flex;align-items:center;gap:8px;margin-top:2px;}',
    '.jfc-sk-price{font-size:14px;font-weight:800;color:#fff;}',
    '.jfc-sk-compare{font-size:11px;color:#6b7280;text-decoration:line-through;}',
    '.jfc-sk-size{font-size:10px;font-weight:600;color:#c4b5fd;background:rgba(168,85,247,.15);padding:1px 6px;border-radius:3px;}',
    '.jfc-sk-btn{background:linear-gradient(135deg,#8b5cf6,#7c3aed);color:#fff;border:none;border-radius:8px;padding:12px 24px;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;white-space:nowrap;display:flex;align-items:center;gap:6px;transition:box-shadow .2s,background .2s;box-shadow:0 2px 12px rgba(124,58,237,.3);touch-action:manipulation;-webkit-tap-highlight-color:transparent;flex-shrink:0;}',
    '.jfc-sk-btn:hover{box-shadow:0 4px 20px rgba(124,58,237,.45);background:linear-gradient(135deg,#9333ea,#7c3aed);}',
    '.jfc-sk-btn:active{box-shadow:0 1px 6px rgba(124,58,237,.2);}',
    '.jfc-sk-btn:disabled{opacity:.5;cursor:not-allowed;background:#374151 !important;box-shadow:none !important;}',
    '.jfc-sk-btn.jfc-sk-ok{background:linear-gradient(135deg,#22c55e,#16a34a) !important;box-shadow:0 2px 12px rgba(34,197,94,.3) !important;}',
    '@media(max-width:749px){#jfc-sticky{padding:8px 0 calc(8px + env(safe-area-inset-bottom));}.jfc-sk-inner{flex-wrap:wrap;gap:8px;padding:0 12px;}.jfc-sk-left{flex:1;min-width:0;}.jfc-sk-title{max-width:140px;font-size:11px;}.jfc-sk-img{width:40px;height:40px;}.jfc-sk-btn{width:100%;justify-content:center;padding:14px 20px;font-size:14px;border-radius:10px;min-height:48px;}}',
    '@media(max-width:380px){.jfc-sk-title{max-width:100px;}}'
  ].join('\n');
  document.head.appendChild(css);

  /* ── Build HTML ── */
  var bar = document.createElement('div');
  bar.id = 'jfc-sticky';
  bar.innerHTML =
    '<div class="jfc-sk-inner">' +
      '<div class="jfc-sk-left">' +
        '<img class="jfc-sk-img" id="jfc-sk-img" src="" alt="">' +
        '<div class="jfc-sk-info">' +
          '<div class="jfc-sk-title" id="jfc-sk-title"></div>' +
          '<div class="jfc-sk-meta">' +
            '<span class="jfc-sk-price" id="jfc-sk-price"></span>' +
            '<span class="jfc-sk-compare" id="jfc-sk-compare"></span>' +
            '<span class="jfc-sk-size" id="jfc-sk-size"></span>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button class="jfc-sk-btn" id="jfc-sk-btn" type="button">' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<span id="jfc-sk-btn-txt">Add to Cart</span>' +
      '</button>' +
    '</div>';
  document.body.appendChild(bar);

  /* ── Populate data ── */
  var titleEl = document.querySelector('.product__title h1, .product__title h2, .product__title');
  var imgEl = document.querySelector('.product__media img, .product--media img');
  var skTitle = document.getElementById('jfc-sk-title');
  var skImg = document.getElementById('jfc-sk-img');
  var skPrice = document.getElementById('jfc-sk-price');
  var skCompare = document.getElementById('jfc-sk-compare');
  var skSize = document.getElementById('jfc-sk-size');
  var skBtn = document.getElementById('jfc-sk-btn');
  var skBtnTxt = document.getElementById('jfc-sk-btn-txt');

  if(titleEl) skTitle.textContent = titleEl.textContent.trim();
  if(imgEl) skImg.src = imgEl.src;

  function updatePrice(){
    var priceEl = document.querySelector('.price-item--regular, .price .money, .jfc-price-main');
    var compareEl = document.querySelector('.price-item--compare, .price--compare .money, .jfc-price-compare');
    if(priceEl) skPrice.textContent = priceEl.textContent.trim();
    if(compareEl && compareEl.textContent.trim()) {
      skCompare.textContent = compareEl.textContent.trim();
      skCompare.style.display = '';
    } else {
      skCompare.style.display = 'none';
    }
  }

  function updateSize(){
    var checked = document.querySelector('input[name="Size"]:checked + label, .variant-input-wrap input:checked + label');
    var s = checked ? checked.textContent.trim().replace(/Variant.*/, '') : '';
    if(!s){
      var sel = document.querySelector('select[name="Size"] option:checked');
      s = sel ? sel.value : '';
    }
    if(s) {
      skSize.textContent = s;
      skSize.style.display = '';
    } else {
      skSize.style.display = 'none';
    }
  }

  function updateAvailability(){
    var mainBtn = document.querySelector('.product-form__submit');
    if(mainBtn && (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true')){
      skBtn.disabled = true;
      skBtnTxt.textContent = 'Sold Out';
    } else {
      skBtn.disabled = false;
      skBtnTxt.textContent = 'Add to Cart';
    }
  }

  updatePrice();
  updateSize();
  updateAvailability();

  /* ── Watch for variant changes ── */
  var variantInput = document.querySelector('.product-variant-id');
  if(variantInput){
    var mo = new MutationObserver(function(){
      updatePrice();
      updateSize();
      updateAvailability();
      /* Update image to variant image */
      setTimeout(function(){
        var newImg = document.querySelector('.product__media.is-active img, .product__media:first-child img, .product--media img');
        if(newImg && newImg.src) skImg.src = newImg.src;
      }, 300);
    });
    mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

  /* Also listen for change events */
  document.addEventListener('change', function(e){
    if(e.target.closest && (e.target.closest('.product-form__input--pill') || e.target.name === 'Size')){
      setTimeout(function(){ updateSize(); updatePrice(); updateAvailability(); }, 100);
    }
  });

  /* ── Show/hide with IntersectionObserver ── */
  var mainBtn = document.querySelector('.product-form__submit');
  if(mainBtn && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        bar.classList.toggle('vis', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px' });
    io.observe(mainBtn);
  }

  /* ── Add to cart via AJAX ── */
  skBtn.addEventListener('click', function(){
    if(skBtn.disabled) return;
    var vid = document.querySelector('.product-variant-id');
    if(!vid || !vid.value) return;

    skBtn.disabled = true;
    skBtnTxt.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(vid.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if(data.status && data.status >= 400){
        skBtnTxt.textContent = 'Error';
        setTimeout(function(){ skBtn.disabled = false; skBtnTxt.textContent = 'Add to Cart'; }, 2000);
        return;
      }
      /* Success */
      skBtn.classList.add('jfc-sk-ok');
      skBtnTxt.textContent = 'Added!';

      /* Re-render drawer + bubble via Dawn (renderContents also opens the drawer) —
         keeps drawer state in sync so it can never show a stale "empty" cart */
      var drawer = document.querySelector('cart-drawer');
      if (drawer && data && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        /* Fallback: keep the header count honest */
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var badges = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble');
          badges.forEach(function(b){
            var s = b.querySelector('span[aria-hidden="true"]');
            if(s) s.textContent = cart.item_count;
          });
        });
      }

      setTimeout(function(){
        skBtn.classList.remove('jfc-sk-ok');
        skBtn.disabled = false;
        skBtnTxt.textContent = 'Add to Cart';
      }, 2200);
    })
    .catch(function(){
      skBtnTxt.textContent = 'Error';
      setTimeout(function(){ skBtn.disabled = false; skBtnTxt.textContent = 'Add to Cart'; }, 2000);
    });
  });

})();
